import { AMLForms } from '@/components/aml-forms';

export function AMLFormsPage() {
  return <AMLForms />;
}
